import { FaRegNewspaper } from "react-icons/fa";
import { GoMegaphone } from "react-icons/go";

import "./MainBodyTwo.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  getHotNews,
  getMostReadPosts,
  getPosts,
  getTrendyPosts,
} from "../../redux/features/post/postSlice";

import moment from "moment";
import DOMPurify from "dompurify";
import { shortenText } from "../../utils";
import HeadingTitle from "../headingTitle/HeadingTitle";
import { MdOutlineThumbUpOffAlt, MdVisibility } from "react-icons/md";
import { Link } from "react-router-dom";
import { IoMdChatboxes } from "react-icons/io";
const MainBodyTwo = () => {
  const dispatch = useDispatch();
  const [hotNewss, setHotNews] = useState(false);
  const [trendingNews, setTrendingNews] = useState(false);
  const [mostWatchedNews, setMostWatchedNews] = useState(false);

  const handleHotNews = (e) => {
    setHotNews(true);
    setTrendingNews(false);
    setMostWatchedNews(false);
  };

  const handleTrendingNews = (e) => {
    setTrendingNews(true);
    setHotNews(false);
    setMostWatchedNews(false);
  };

  const handleMostWatchedNews = (e) => {
    setMostWatchedNews(true);
    setHotNews(false);
    setTrendingNews(false);
  };

  useEffect(() => {
    setTrendingNews(true);
  }, [setTrendingNews]);

  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);
  const { adds } = useSelector((state) => state.add);
  const { posts } = useSelector((state) => state.post);
  const business = posts.find((post) => post.category === "Business");
  const sports = posts.find((post) => post.category === "Sports");

  useEffect(() => {
    dispatch(getTrendyPosts());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getMostReadPosts());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getHotNews());
  }, [dispatch]);

  const { trendyPosts } = useSelector((state) => state.post);
  const { mostRead } = useSelector((state) => state.post);
  const { hotNews } = useSelector((state) => state.post);

  const trend = Array.isArray(trendyPosts)
    ? trendyPosts.filter((post) => post.views > 0).slice(0, 5)
    : [];

  const mostRd = Array.isArray(mostRead)
    ? mostRead.filter((post) => post.views > 0).slice(0, 5)
    : [];

  const hot = Array.isArray(hotNews)
    ? hotNews.filter((news) => news.views > 0).slice(0, 5)
    : [];

  const adsMainTwo = adds
    ?.filter((ads) => {
      return ads?.category === "Advert Main2";
    })
    ?.filter((ads, index) => index < 4);

  const worldNewsB = posts
    ?.filter((news) => {
      return news?.category === "World News";
    })
    ?.filter((news, index) => index < 4);

  const entertainmentB = posts
    ?.filter((ent) => {
      return ent?.category === "Entertainment";
    })
    ?.filter((ent, index) => index < 4);

  const businessB = posts
    ?.filter((biz) => {
      return biz?.category === "Business";
    })
    ?.filter((biz, index) => index < 4);

  const SportsB = posts
    ?.filter((sport) => {
      return sport?.category === "Sports";
    })
    ?.filter((sport, index) => index < 4);

  return (
    <div className="mainBodyTwo">
      <div className="mainBodyTwoWrapper">
        {/* StyleTwo Right  Business*/}
        <div className="styleOne1">
          <div className="item">
            <div className="styleTwo">
              <HeadingTitle title={business?.category} />

              <div className="top">
                <img src={business?.image[0]} alt="" />
                <Link className="cat">{business?.type}</Link>
                <Link className="icon">
                  {" "}
                  <MdVisibility style={{ fontSize: "20px" }} />
                </Link>

                {/* <div className="postInfo">
                  <ul className="nav">
                    <li>{business?.author}</li>
                    <li>{d}</li>
                  </ul>
                  <h3
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        shortenText(sports?.title, 50)
                      ),
                    }}
                  ></h3>
                </div> */}
              </div>

              <div className="bottom">
                {businessB.map((biz) => {
                  return (
                    <div className="item" key={biz._id}>
                      <div className="left">
                        <Link to={`/page/${biz.slug}`}>
                          <img src={biz?.image[0]} alt="" />
                        </Link>
                        <div className="likeComment">
                          <div className="left">
                            <div className="lkicon">
                              <MdOutlineThumbUpOffAlt
                                color="#ff9f31"
                                size={20}
                              />
                              {biz?.likes?.length > 0 && biz?.likes?.length}
                            </div>
                          </div>
                          <div className="right">
                            <div className="cmticon">
                              <IoMdChatboxes color="#ff9f31" size={20} />
                              {biz?.comments?.length > 0 &&
                                biz?.comments?.length}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="right">
                        <ul className="nav">
                          <li>{biz?.author}</li>
                          <li>{moment(biz.createdAt).format("DD-MMM-YYYY")}</li>
                        </ul>
                        <Link to={`/page/${biz.slug}`}>
                          <h3
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                shortenText(biz?.title, 90)
                              ),
                            }}
                          ></h3>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>{" "}
        </div>

        {/* StyleTwo Right  Sports*/}
        <div className="styleOne1">
          <div className="item">
            <div className="styleTwo">
              <HeadingTitle title={sports?.category} />

              <div className="top">
                <img src={sports?.image[0]} alt="" />
                <Link className="cat">{sports?.type}</Link>
                <Link className="icon">
                  {" "}
                  <MdVisibility style={{ fontSize: "20px" }} />
                </Link>

                {/* <div className="postInfo">
                  <ul className="nav">
                    <li>{sports?.author}</li>
                    <li>{d}</li>
                  </ul>
                  <h3
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        shortenText(sports?.title, 50)
                      ),
                    }}
                  ></h3>
                </div> */}
              </div>

              <div className="bottom">
                {SportsB.map((sport) => {
                  return (
                    <div className="item" key={sport._id}>
                      <div className="left">
                        <Link to={`/page/${sport.slug}`}>
                          <img src={sport?.image[0]} alt="" />
                        </Link>
                        <div className="likeComment">
                          <div className="left">
                            <div className="lkicon">
                              <MdOutlineThumbUpOffAlt
                                color="#ff9f31"
                                size={20}
                              />
                              {sport?.likes?.length > 0 && sport?.likes?.length}
                            </div>
                          </div>
                          <div className="right">
                            <div className="cmticon">
                              <IoMdChatboxes color="#ff9f31" size={20} />
                              {sport?.comments?.length > 0 &&
                                sport?.comments?.length}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="right">
                        <ul className="nav">
                          <li>{sport?.author}</li>
                          <li>
                            {moment(sport.createdAt).format("DD-MMM-YYYY")}
                          </li>
                        </ul>
                        <Link to={`/page/${sport.slug}`}>
                          <h3
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                shortenText(sport?.title, 90)
                              ),
                            }}
                          ></h3>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>{" "}
        </div>

        <div className="styleThree">
          <div className="widgets">
            <div className="widgetTitle">
              <h2>Featured News</h2>
              <FaRegNewspaper className="icon" />
            </div>

            <div className="list">
              <div className="top">
                <ul>
                  <li
                    className={hotNewss ? "active" : ""}
                    onClick={handleHotNews}
                  >
                    <Link className="hotNews">Hot News</Link>
                  </li>
                  <li
                    className={trendingNews ? "active" : ""}
                    onClick={handleTrendingNews}
                  >
                    <Link className="trendyNews">Trendy News</Link>
                  </li>
                  <li
                    className={mostWatchedNews ? "active" : ""}
                    onClick={handleMostWatchedNews}
                  >
                    <Link className="mostWatched">Most Read</Link>
                  </li>
                </ul>
              </div>

              {hotNewss && (
                <div className="bottom">
                  {hot.map((news) => {
                    let date = new Date(news?.createdAt);

                    const d = date.toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    });
                    return (
                      <div className="item" key={news._id}>
                        <div className="left">
                          <Link to={`/page/${news.slug}`}>
                            <img src={news.image[0]} alt="" />
                          </Link>
                        </div>
                        <div className="right">
                          <ul className="nav">
                            <li>{news?.author}</li>
                            <li>{d}</li>
                          </ul>
                          <Link to={`/page/${news.slug}`}>
                            <h3
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                  shortenText(news?.title, 90)
                                ),
                              }}
                            ></h3>
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {trendingNews && (
                <div className="bottom">
                  {trend.map((pst) => {
                    let date = new Date(pst?.createdAt);

                    const d = date.toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    });
                    return (
                      <div className="item" key={pst._id}>
                        <div className="left">
                          <Link to={`/page/${pst.slug}`}>
                            <img src={pst.image[0]} alt="" />
                          </Link>
                        </div>
                        <div className="right">
                          <ul className="nav">
                            <li>{pst?.author}</li>
                            <li>{d}</li>
                          </ul>
                          <Link to={`/page/${pst.slug}`}>
                            <h3
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                  shortenText(pst?.title, 90)
                                ),
                              }}
                            ></h3>
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {mostWatchedNews && (
                <div className="bottom">
                  {mostRd.map((most) => {
                    let date = new Date(most?.createdAt);

                    const d = date.toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    });
                    return (
                      <div className="item" key={most._id}>
                        <div className="left">
                          <Link to={`/page/${most.slug}`}>
                            <img src={most.image[0]} alt="" />
                          </Link>
                        </div>
                        <div className="right">
                          <ul className="nav">
                            <li>{most?.author}</li>
                            <li>{d}</li>
                          </ul>
                          <Link to={`/page/${most.slug}`}>
                            <h3
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                  shortenText(most?.title, 90)
                                ),
                              }}
                            ></h3>
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          <div className="widgets">
            <div className="widgetTitle">
              <h2 className="h4">Advertisement</h2>
              <GoMegaphone className="icon" />
            </div>

            <div className="adWidget">
              {adsMainTwo.map((ads) => {
                return (
                  <Link to={ads.link} target="_blank">
                    <img src={ads.image} alt="" />
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MainBodyTwo;
